import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from '@material-tailwind/react';

const CommonTab = ({ tabList, setCurrentTab, currentTab }) => {
  return (
    <section className='tabsSec mx-full flow'>
      <Tabs className='justify-start ' value={currentTab}>
        <TabsHeader
          className={`mx-0 ${
            tabList?.length > 5 ? 'sm:max-w-7xl' : 'max-w-2xl'
          } pb-3 overflow-x-auto flex  items-baseline flex-row rounded-xl bg-transparent`}>
          {tabList.map((tab) => (
            <Tab
              onClick={() => {
                setCurrentTab(tab?.name);
              }}
              key={`tabsId${tab?.id}`}
              value={tab.name}
              className={`capitalize tabsButton w-full sm:w-fit rounded-full mx-1 sm:mx-2 my-2 py-2 px-5 sm:py-2.5 sm:px-6 border border-transparent tracking-wider text-sm font-medium leading-5 text-eventGray bg-eventLGray focus-visible:outline-none whitespace-nowrap ${
                tab?.name === currentTab
                  ? 'bg-eventLightYellow shadow text-white font-semibold tracking-wide'
                  : 'text-eventGray hover:text-eventLightYellow'
              }`}>
              {tab.name}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody
          base={{
            display: 'block',
            width: 'w-full',
          }}>
          {tabList.map((tab, ind) => (
            <TabPanel key={ind} value={tab.name} className='p-0 py-4'>
              {tab.component}
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
    </section>
  );
};

export default CommonTab;
